export default __webpack_public_path__ + "static/media/docx-icon.0eb5877d.png";